// ---------------------------------------------------------------------------
// Digital Notice Board — MarqueeStyle
// ---------------------------------------------------------------------------
// Injects the single @keyframes the scrolling-text (marquee) element relies on.
// Mounted by both the editor page and the projection player so the animation is
// available wherever an ElementVisual is rendered. Rendering it more than once
// is harmless — identical @keyframes just redefine the same animation.
// ---------------------------------------------------------------------------
import React from "react";

const CSS = `
@keyframes nbMarquee {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-100%); }
}
@keyframes nbSpin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.nb-spin { animation: nbSpin 0.6s linear infinite; }
`;

export default function MarqueeStyle() {
    return <style dangerouslySetInnerHTML={{__html: CSS}} />;
}
